import './styles.css';

export const DeactivateIcon = (_props: unknown) => {
  return <button className="deactivate-icon">&nbsp;&nbsp;Deactivate&nbsp;&nbsp;</button>;
};
